module.exports = __webpack_public_path__ + "img/swap-left.bf2f5d85.svg";